import { Add, Close, Lightbulb } from '@mui/icons-material';
import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, LinearProgress, Paper, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Api from "../../customlib/Api";
import Global from "../../customlib/Global";
import axios from "axios";
import FuBlastTeleSetting from './Features/FuBlastTeleSetting';
import FuBlastTeleAllSetting from './Features/FuBlastTeleAllSetting';
import FuBlastTeleRBSetting from './Features/FuBlastTeleRBSetting';
import AutoReplySalesOnline from './Features/AutoReplySalesOnline';
import BlastSetup from '../BlastTelemarketing/Blastsetup';
import FuBlastReminderTeleSetting from './Features/FuBlastReminderTeleSetting';
import FuBlastAkunAdmTeleSetting from './Features/FuBlastAkunAdmTeleSetting';
import FuBlastAkunDataPendingTeleSetting from './Features/FuBlastAkunDataPendingTeleSetting';
import FuBlastAkunDataCancelTeleSetting from './Features/FuBlastAkunDataCancelTeleSetting';

class FeaturesSettings extends Component {
    state = { 
        generalSettings: null,
        isLoading: false,
        showBlastSetup: false
    } 

    loadGeneralSettings = () => {
        this.setState({isLoading: true}, () => {
            axios
                .get(Api.getGeneralSettings(), Api.getRequestHeader())
                .then((response) => {
            
                    console.log("GENERAL_SSETTINGS", response.data);
                
                    var data = response.data;
                
                    this.setState({generalSettings: data.data, isLoading: false});
            
                })
                .catch((error) => {
                    this.setState({isLoading: false});
                    console.error("There was an error!", error);
                });
        });
        

    }

    handleShowBlastSetup = () => {
        this.setState({showBlastSetup: true});
    }

    handleCloseBlastSetup = () => {
        this.setState({showBlastSetup: false});
    }

    componentDidMount() {
        this.loadGeneralSettings();
    }

    render() { 
        return (
            <Paper sx={{padding: "20px", margin: "10px"}}>
                <Box>
                    <Grid container spacing={1}>
                        <Grid item sm={10}>
                            <Typography variant='h5'>Features Settings</Typography>
                        </Grid> 
                        <Grid item sm={1} textAlign={"right"}>
                            <Tooltip title="Add Blast">
                                <Button 
                                    size='small' 
                                    variant='contained' 
                                    color='primary' 
                                    sx={{textTransform: "capitalize"}}
                                    onClick={this.handleShowBlastSetup}
                                >
                                    <Add /> Add Blast
                                </Button>
                            </Tooltip>
                        </Grid> 
                        <Grid item sm={1} textAlign={"right"}>
                            <Tooltip title="Features Settings">
                                <Link to="/">
                                    <IconButton color='error'>
                                        <Close  />
                                    </IconButton>
                                </Link>
                            </Tooltip>
                        </Grid> 
                    </Grid>
                </Box>
                <Divider />
                {
                    this.state.isLoading && (
                        <LinearProgress />
                    )
                }
                {
                    this.state.generalSettings && (
                        <Box sx={{mt: "20px"}}>
                            <Grid container spacing={1}>
                                <Grid item sm={4} xs={12}>
                                    <AutoReplySalesOnline data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>

                                <Grid item sm={4} xs={12}>
                                    <FuBlastTeleSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastTeleAllSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastReminderTeleSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastTeleRBSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastAkunAdmTeleSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastAkunDataPendingTeleSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <FuBlastAkunDataCancelTeleSetting data={this.state.generalSettings} onReload={this.loadGeneralSettings} />       
                                </Grid>
                                
                            </Grid>
                        </Box>
                    )
                }

                <Dialog
                    open={this.state.showBlastSetup}
                    onClose={this.handleCloseBlastSetup}
                    maxWidth={"xl"}
                    fullWidth
                >
                    <BlastSetup data={this.state} onClose={this.handleCloseBlastSetup}/>
                </Dialog>
                
            </Paper>
        );
    }
}
 
export default FeaturesSettings;